import api from '@/api/axios';
import CircularJSON from 'circular-json';
import { mergeData } from '@/utils/helpers';

const SUB_PRIVADA_LOGIN_MSG = 'Esta subasta es privada. Iniciá sesión para verla.';

const redirigirALoginSiCorresponde = (error) => {
  if (error?.response?.status === 403) {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = `/login?error=${encodeURIComponent(SUB_PRIVADA_LOGIN_MSG)}`;
    }
  }
};

const subastaModel = {
    data: {
        id: null,
        titulo: null,
        subtitulo: null,
        estado_subasta: null,
        estado_subasta_id: null,
        modalidad_subasta: null,
        modalidad_subasta_id: null,
        tipo_credito: null,
        tipo_credito_id: null,
        aprobacion_tiempo_dias: null,
        ocultar: false,
        fecha_inicio: null,
        hora_inicio: null,
        fecha_hora_inicio: null,
        fecha_finalizacion: null,
        hora_finalizacion: null,
        fecha_hora_finalizacion: null,
        martillero_asignado: null,
        martillero_asignado_id: null,
        equipo_asignado: null,
        equipo_asignado_id: null,
        descripcion: null,
        comentario_interno: null,
        video_url: null,
        imagen: {
            archivo: null,
            entidad: 'subasta',
            filename: null,
            hash: null,
            extension: null,
            tipo_archivo_id: 1,
        },
        imagen_id: null,
        propietario: {
            id: null,
            razon_social: null,
            cuit: null,
            direccion: null,
            pais: null,
            pais_id: null,
            provincia: null,
            provincia_id: null,
            ciudad: null,
            logo: null,
            logo_id: null,
            industria_primaria: null,
            industria_primaria_id: null,
            industria_secundaria: null,
            industria_secundaria_id: null,
        },
        propietario_id: null,
        created_by: null,
        created_by_id: null,
        updated_by: null,
        updated_by_id: null,
        industrias: [],
        lotes: [],
        multimedia: [],
        ubicaciones: [],
        termino_condicion: {
            archivo_id: null,
            archivo: {
                archivo: null,
                entidad: 'subasta',
                filename: null,
                hash: null,
                extension: 'pdf',
                tipo_archivo_id: 8,
                vista_previa: null
            },
            desde_documento_existente: false,
            guardar_documento: false,
            nombre_documento: '',
            documento_existente: null,
        },
    },

    async obtenerSubasta(id) {
        try {
            const response = await api.get(`/subastas/${id}`);
            const subasta = mergeData(this.data, { ...response.data });

            if (subasta.fecha_hora_inicio) {
                const [fechaInicio, horaInicio] = subasta.fecha_hora_inicio.split(' ');
                subasta.fecha_inicio = fechaInicio;
                subasta.hora_inicio = horaInicio;
            }

            if (subasta.fecha_hora_finalizacion) {
                const [fechaFinzalicion, horaFinzalicion] = subasta.fecha_hora_finalizacion.split(' ');
                subasta.fecha_finalizacion = fechaFinzalicion;
                subasta.hora_finalizacion = horaFinzalicion;
            }

            return subasta;
        } catch (error) {
            console.error("Error al obtener la subasta:", error);
            redirigirALoginSiCorresponde(error);
            throw error;
        }
    },
    async crearSubasta(subasta) {
        try {
            const response = await api.post(
                `/subastas`,
                CircularJSON.stringify(subasta),
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data.id;
        } catch (error) {
            if (error.response) {
                console.error("Error en la respuesta del servidor:", error.response.data);
            } else {
                console.error("Error en la solicitud:", error.message);
            }
            throw error;
        }
    },
    async actualizarSubasta(subasta) {
        try {
            if (!subasta.id)
                return;
            const response = await api.put(
                `/subastas/${subasta.id}`,
                CircularJSON.stringify(subasta),
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data.id;
        } catch (error) {
            if (error.response) {
                console.error("Error en la respuesta del servidor:", error.response.data);
            } else {
                console.error("Error en la solicitud:", error.message);
            }
            throw error;
        }
    },
    async getSubastas(filtros = {}) {
        try {
            const response = await api.get('/subastas', {
            params: filtros
            });
            return response.data;
        } catch (error) {
            console.error("Error al obtener subastas:", error);
            throw error;
        }
    },
    
    async obtenerSubastaConLotes(id) {
        try {
            const response = await api.get(`/subastas/${id}`);
            const subasta = response.data;

            return subasta;
        } catch (error) {
            console.error("Error al obtener la subasta:", error);
            redirigirALoginSiCorresponde(error);
            throw error;
        }
    },

    async obtenerAceptoTerminos(subasta_id) {
        try {
            const response = await api.get(`/subastas/${subasta_id}/acepto-terminos-condiciones`);
            const acepto = response.data;
            return acepto;
        } catch (error) {
            console.error("Error al obtener acepto los terminos y condiciones:", error);
            throw error;
        }
    },

    async aceptarTerminosCondiciones(subasta_id) {
        try {
            const response = await api.post(`/subastas/terminos-condiciones`, {
                subasta_id: subasta_id,
            });
            const acepto = response.data;
            return acepto;
        } catch (error) {
            console.error("Error al obtener acepto los terminos y condiciones:", error);
            throw error;
        }
    },



};

export default subastaModel;